export const getAdditionalFeesOrderItems = fees => (fees == null ? void 0 : fees.map(fee => {
  var _fee$price;
  return {
    id: fee.code,
    name: fee.name ?? '',
    price: ((_fee$price = fee.price) == null ? void 0 : _fee$price.amount) ?? '0',
    quantity: 1
  };
})) || [];
//# sourceMappingURL=getAdditionalFeesOrderItems.js.map